import React from 'react';
import { Provider } from 'react-redux';
import { RouterProvider } from 'react-router';
import { PersistGate } from 'redux-persist/integration/react';

import UnsupportedBrowserBanner from 'components/ui/UnsupportedBrowserBanner';

import IntlWrapper from './Intl';
import { router } from './dataRouter';
import { store, persistor } from './Store';

import '../styles/vendor.css';

const App: React.FC = () => (
  <React.StrictMode>
    <Provider store={store}>
      {/* PersistGate is used to display a loader while the store is rehydrated */}
      <PersistGate persistor={persistor} loading={null}>
        <IntlWrapper>
          <UnsupportedBrowserBanner />
          <RouterProvider router={router} />
        </IntlWrapper>
      </PersistGate>
    </Provider>
  </React.StrictMode>
);

export default App;
